export default {
  GET_LOTTERY_PRIZES_REQUEST: '@@lottery/GET_OPERATION_EMAIL_TEMPLATES_REQUEST',
  GET_LOTTERY_PRIZES_SUCCESS: '@@lottery/GET_OPERATION_EMAIL_TEMPLATES_SUCCESS',
  GET_LOTTERY_PRIZES_ERROR: '@@lottery/GET_OPERATION_EMAIL_TEMPLATES_ERROR',

  CHANGE_LOTTERY_PRIZE_ORDER: '@@lottery/CHANGE_LOTTERY_PRIZE_ORDER',
};
